








import Vue, { PropType } from "vue";
import log from "loglevel";
import Ice from "@/lib/ice";

import { PostChangePlansRequest } from "@/containers/changePlans/api";

export interface ChangePlansRegisterProps {
  apiRequestParams: PostChangePlansRequest;
  waitingTime: number;
  errorUrl: string;
  postChangePlansRegister: any;
}

export interface ChangePlansRegisterData {
  isComplete: boolean;
}

export default Vue.extend({
  name: "vc-change-plans-register",
  props: {
    apiRequestParams: {
      type: Object as PropType<ChangePlansRegisterProps["apiRequestParams"]>,
      default: {}
    },
    waitingTime: {
      type: Number as PropType<ChangePlansRegisterProps["waitingTime"]>,
      default: 0
    },
    errorUrl: {
      type: String as PropType<ChangePlansRegisterProps["errorUrl"]>,
      default: ""
    },

    // actionsToProps
    postChangeContract: {
      type: Function as PropType<
        ChangePlansRegisterProps["postChangePlansRegister"]
      >,
      default: () => {}
    }
  },
  data(): ChangePlansRegisterData {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.executionPostChangePlans();
  },
  methods: {
    async executionPostChangePlans() {
      try {
        const res = await this.postChangeContract(this.apiRequestParams);

        // PAY-1594の対応
        // 契約変更の処理内容によってはsetActiveMenuの実行タイミングとかぶってリクエストがcanceledになることがあるため、かぶらないように2秒待つ
        setTimeout(() => {
          this.isComplete = true;
          window.location.href = res.returnUrl;
        }, 2000);
      } catch (error) {
        log.error(error);

        if (error.data && error.data.returnUrl) {
          window.location.href = error.data.returnUrl;
        } else {
          window.location.href = this.errorUrl + "?type=default_error";
        }

        throw error;
      }
    }
  }
});
